import { c as _c } from "react/compiler-runtime";
import { useIsMutating } from "@tanstack/react-query";
import { addCustomerAddressMutationKey } from "@/mutations/useAddCustomerAddressMutation";
import { addEmailMutationKey } from "@/mutations/useAddEmailMutation";
import { addGuestAddressMutationKey } from "@/mutations/useAddGuestAddressMutation";
import { applyCouponMutationKey } from "@/mutations/useApplyCoupon";
import { billingAddressMutationKey } from "@/mutations/useBillingAddressMutation";
import { addToCartMutationKey, updateCartItemMutationKey } from "@/mutations/useCartMutation";
import { deliveryOptionMutationKey } from "@/mutations/useDeliveryOptionMutation";
import { duplicateCartItemMutationKey } from "@/mutations/useDuplicateCartItem";
import { estimatedShippingMutationKey } from "@/mutations/useEstimatedShippingArea";
import { finalizeCreditCardMutationKey } from "@/mutations/useFinalizeCreditCardPayment";
import { finalizePayPalMutationKey } from "@/mutations/useFinalizePayPalPayment";
import { initializePayPalMutationKey } from "@/mutations/useInitializePayPalPayment";
import { removeCartItemMutationKey } from "@/mutations/useRemoveCartItem";
import { removeCouponMutationKey } from "@/mutations/useRemoveCoupon";
import { shippingAddressMutationKey } from "@/mutations/useShippingAddressMutation";
import { updateCustomerAddressMutationKey } from "@/mutations/useUpdateCustomerAddressMutation";
import { updateItemQuantityMutationKey } from "@/mutations/useUpdateItemQuantity";
const CART_MUTATION_KEYS: readonly string[] = [...addToCartMutationKey, ...updateCartItemMutationKey, ...updateItemQuantityMutationKey, ...removeCartItemMutationKey, ...duplicateCartItemMutationKey, ...applyCouponMutationKey, ...removeCouponMutationKey, ...estimatedShippingMutationKey, ...addEmailMutationKey, ...shippingAddressMutationKey, ...addCustomerAddressMutationKey, ...updateCustomerAddressMutationKey, ...addGuestAddressMutationKey, ...deliveryOptionMutationKey, ...billingAddressMutationKey, ...finalizeCreditCardMutationKey, ...initializePayPalMutationKey, ...finalizePayPalMutationKey];
export function useIsCartMutating() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      predicate: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const count = useIsMutating(t0);
  return count > 0;
}
function _temp(mutation) {
  const key = mutation.options.mutationKey?.[0];
  return typeof key === "string" && CART_MUTATION_KEYS.includes(key);
}